import { Button, ButtonGroup, Paper, Popper, Typography } from "@mui/material";

const ConfirmCreditConnection = ({
  open,
  onClose,
  onConfirm,
  anchorRef,
  credit,
  invoice,
}) => {
  return (
    <Popper
      open={open}
      anchorEl={anchorRef.current}
      placement="bottom-start"
      style={{ zIndex: 1300, marginLeft: "150px" }}
    >
      <Paper sx={{ minHeight: "100px", padding: "10px" }} elevation={5}>
        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
          <Typography variant="h6">{"Koppla kredit"}</Typography>
          <div>
            <span>{`Vill du koppla kredit `}</span>
            <span style={{ fontWeight: "bold" }}>
              {credit?.ExternalInvoiceNumber}
            </span>
            <span>{" mot faktura "}</span>
            <span style={{ fontWeight: "bold" }}>
              {invoice?.ExternalInvoiceNumber}
            </span>
            <span>{" i reskontra?"}</span>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <Button
              variant="contained"
              size="small"
              onClick={() => onConfirm()}
            >
              Ja
            </Button>
            <Button size="small" onClick={() => onClose()}>
              Nej
            </Button>
          </div>
        </div>
      </Paper>
    </Popper>
  );
};

export default ConfirmCreditConnection;
